// Déplacez ici EXTRA_OPTIONS depuis AdvancedConfigPage, inchangé, puis importez-le des deux côtés.

export const KM_OPTIONS = [
  ['0', '0-15 000 km'],
  ['1', '15-50 000 km'],
  ['2', '50-100 000 km'],
  ['3', '100-150 000 km'],
  ['4', '150-200 000 km'],
  ['5', '+200 000 km'],
];

export const FUEL_OPTIONS = [
  ['0', 'Électrique'],
  ['1', 'Diesel'],
  ['2', 'Essence'],
  ['3', 'Hydrogène'],
  ['4', 'Hybride'],
  ['5', 'GPL'],
];

export const DAY_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export const EXTRA_OPTIONS = [
  { id: '1', label: 'Climatisation', icon: 'snow-outline' },
  { id: '2', label: 'Régulateur de vitesse', icon: 'speedometer-outline' },
  { id: '3', label: 'GPS', icon: 'navigate-circle-outline' },
  { id: '4', label: 'Siège bébé', icon: 'egg-outline' },
  { id: '5', label: 'Coffre de toit', icon: 'cube-outline' },
  { id: '6', label: 'Porte-vélos', icon: 'bicycle-outline' },
  { id: '7', label: 'Pneus neige', icon: 'snow-outline' },
  { id: '8', label: 'Chaînes', icon: 'link-outline' },
  { id: '9', label: 'Porte-skis', icon: 'trail-sign-outline' },
  { id: '10', label: 'Entrée audio iPod', icon: 'musical-notes-outline' },
  { id: '11', label: 'Audio Bluetooth', icon: 'bluetooth-outline' },
  { id: '12', label: 'Attelage', icon: 'git-merge-outline' },
  { id: '13', label: 'Accessible fauteuil roulant', icon: 'accessibility-outline' },
  { id: '14', label: 'Apple CarPlay', icon: 'logo-apple' },
  { id: '15', label: 'Android Auto', icon: 'logo-android' },
];

export const STEP_LABELS = ['Caractéristiques', 'Options', 'Photos et facturation'];
